import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ palette }) => ({
    ui_icon_standard: {
        color: ({ variant }) => ({
            error: palette.error.dark,
            info: palette.info.dark,
            warning: palette.warning.dark,
        }[variant]),
    },
}));
//# sourceMappingURL=ui_icon_standard.css.js.map